import strings from 'common/Translation/Translate';

/**
 * Human-readable label for API field names on the SA booking lookup screen.
 * Uses `sa_booking_lbl_<fieldName>` from translations when present.
 */
export function getSaBookingFieldLabel(field: string): string {
  const key = `sa_booking_lbl_${field}`;
  const bag = strings as unknown as Record<string, string | undefined>;
  const localized = bag[key];
  if (localized && localized.length > 0) {
    return localized;
  }
  return humanizeApiField(field);
}

function humanizeApiField(field: string): string {
  const spaced = field.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ');
  const titled = spaced.replace(/^\w/, c => c.toUpperCase());
  return titled.replace(/\bId\b/g, 'ID');
}
